import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { AccrualImporterContextProvider } from "./AccrualImporterContextProvider";
import { AccrualImporterDraftsView } from "./AccrualImporterDraftsView";
import { AccrualDocumentImporterMode } from "./accrualDocumentImporter.lib";

interface Props {
    mode: AccrualDocumentImporterMode;
}

const PARENT_PATH: Record<AccrualDocumentImporterMode, string> = {
    invoices: "/invoicing",
    bills: "/billing",
};

export const AccrualImporterDraftsPage: React.FC<Props> = ({ mode }) => {
    const navigate = useStateAwareNavigate();

    return (
        <AccrualImporterContextProvider
            mode={mode}
            readyToImportLabel="Ready to import"
        >
            <AccrualImporterDraftsView
                onHide={() => navigate(PARENT_PATH[mode])}
            />
        </AccrualImporterContextProvider>
    );
};
